import { render, staticRenderFns } from "./MemberLayout.vue?vue&type=template&id=4fd563d3&"
import script from "./MemberLayout.vue?vue&type=script&lang=js&"
export * from "./MemberLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports